import { strtrim, strempty, isEuCountry, onLoginSuccess, getCountryCode, redirectIfLoggedIn, setAnalyticsIdentity, logUserActivity, getLoggedInUser } from './utils'

let isEurope = false;
let referralId;

try {
     const user = getLoggedInUser()
     if (user) {
        logUserActivity('VIEW_SIGNUP', user.username, { user })
     } else {
        logUserActivity('GUEST_VIEW_SIGNUP')
     }
} catch (error) {
    console.error('Error in Analytics:', error)
}

document.addEventListener('DOMContentLoaded', function() {
    redirectIfLoggedIn();
    const queryParams = new URLSearchParams(window.location.search);
    referralId = queryParams.get('referralId') || null; // FIXME: Need to handle this?
    const stubEmail = window.sessionStorage.getItem('user-stub-email');

    isEuCountry().then(isEU => {
        isEurope = isEU;
        renderComplianceFields(isEU, stubEmail);
    });

    renderRefererFields($('#referer').val());
    renderForUserStub(stubEmail);

    $('#referer').on('change', ev => renderRefererFields(ev.target.value));
    $('#wf-form-signup').on('submit', handleFormSubmit);
});

function setError(msg) {
    $('#form-error').text(msg)
    $('#error-container').show();
}

async function handleFormSubmit(ev) {
    ev.preventDefault();

    const stubEmail = window.sessionStorage.getItem('user-stub-email');
    const formData = { gdprCheckboxData: {}, email: stubEmail };
    $(ev.target).serializeArray().forEach(({ name, value }) => {
        if (name === 'email' && !stubEmail) {
            formData.email = strtrim(value)
        } else if (name === 'username') {
            formData.username = strtrim(value)
        } else if (name === 'password') {
            formData.password = value;
        } else if (name === 'confirm-password') {
            formData.password2 = value;
        } else if (name === 'referer') {
            formData.referer = value;
        } else if (name === 'referer-other' || name === 'referer-influencer') {
            formData.refererDetail = value;
        } else if (name === 'marketing-opt-in' && isEurope && !stubEmail) {
            console.log(name, value);
            formData.gdprCheckboxData.doReceiveAnnouncements = true;
        } else if (name === 'accept-privacy-terms' && isEurope && !stubEmail) {
            console.log(name, value);
            formData.gdprCheckboxData.doConfirmPolicy = true;
        }
    })

    if (isEurope && !formData.gdprCheckboxData.doConfirmPolicy && !stubEmail) {
        setError('Please confirm the gdpr policy.');
        return;
    }
    if (strempty(formData.email)) {
        setError('Please fill out the email.');
        return;
    }
    if (strempty(formData.username)) {
        setError('Please fill out the username.');
        return;
    }
    if (strempty(formData.password)) {
        setError('Please set your password.');
        return;
    }

    formData.countryCode = await getCountryCode();
    formData.campaigns = JSON.parse(localStorage.getItem('campaigns')) || [];

    console.log(formData, formData);

    $.ajax({
        method: 'POST',
        url: `${window.apiHost}/api/v1/users`,
        data: JSON.stringify(formData),
        dataType: 'json',
        contentType: 'application/json',
        error: (response) => {
            const { code, what, min, max, reason } = response.responseJSON || {}
            console.log('failure response=%O', response.responseJSON)
            console.log('failure code=' + code)
            if (code === 'unauthorized') {
                setError('Username does not exist or the credentials do not match.')
            } else if (code === 'duplicate') {
                if (what === 'email') {
                    window.sessionStorage.removeItem('user-stub-email');
                    renderForUserStub(null);
                    setError('An account already exists with this email.')
                } else if (what === 'username') {
                    setError('Sorry, that username is already taken.')
                }
            } else if (code === 'invalid_username') {
                if (reason === 'too_short') {
                    setError(`Username must be at least ${min} characters long.`)
                } else if (reason === 'too_long') {
                    setError(`The username is too long.`)
                } else {
                    setError(`The username is invalid.`)
                }
            } else if (code === 'invalid_email') {
                window.sessionStorage.removeItem('user-stub-email');
                renderForUserStub(null);
                setError(`That doesn't look like a valid email address.`)
            } else if (code === 'invalid_password') {
                if (reason === 'too_short') {
                    setError(`Password must be at least ${min} characters long.`)
                } else if (reason === 'too_long') {
                    setError(`The password is too long.`)
                } else {
                    setError(`The password is invalid.`)
                }
            } else {
                setError(`There was a problem while logging you in. code=${code}`)
            }
        },
    })
        .done(response => {
            const { token, user } = response;
            try {
                setAnalyticsIdentity(user.urn, { user, campaigns: formData.campaigns })
                logUserActivity('ACCOUNT_CREATED', user.username, { user, campaigns: formData.campaigns})
            } catch (error) {
                console.error('Error in Analytics:', error)
            } finally {
                onLoginSuccess(token, user, 'personalize');
            }
        });
}

function renderForUserStub(email) {
    if (email) {
        $('#email-field').hide();
        $('#email-2').prop('required', false);
        $('#referer-fields').hide();
        $('#global').hide();
        $('#gdpr').hide();
    } else {
        $('#email-field').show();
        $('#email-2').prop('required', true);
        $('#referer-fields').show();
    }
    renderComplianceFields(isEurope, email);
}

function renderRefererFields(referer) {
    if (referer === 'influencer') {
        $('#referer-influencer-container').show();
    } else {
        $('#referer-influencer-container').hide();
    }

    if (referer === 'other') {
        $('#referer-other-container').show();
    } else {
        $('#referer-other-container').hide();
    }
}

function renderComplianceFields(isEU, stubEmail) {
    if (stubEmail) {
        $('#gdpr').hide();
        $('#global').hide();
    } else {
        if (isEU) {
            $('#gdpr').show();
            $('#global').hide();
        } else {
            $('#global').show();
            $('#gdpr').hide();
        }
    }
}
